import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      const el = e.target;
      setHover(!!(el.closest && el.closest(".cursor-hover, a, button, input, textarea, select")));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <motion.div
      className="hidden lg:block fixed top-0 left-0 z-[9999] pointer-events-none mix-blend-difference"
      animate={{ x: pos.x - (hover ? 20 : 5), y: pos.y - (hover ? 20 : 5), scale: hover ? 1 : 1 }}
      transition={{ type: "spring", stiffness: 500, damping: 40, mass: 0.4 }}
    >
      <div
        className="rounded-full bg-white transition-all duration-300"
        style={{ width: hover ? 40 : 10, height: hover ? 40 : 10 }}
      />
    </motion.div>
  );
}
